var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGarbage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 14 14",
    style: {
      enableBackground: "new 0 0 14 14"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#CC;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "9.7,0.8 8.9,0 5.1,0 4.3,0.8 1.6,0.8 1.6,2.3 12.4,2.3 12.4,0.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.3,3.1v9.3C2.3,13.3,3,14,3.9,14h6.2c0.9,0,1.6-0.7,1.6-1.6V3.1H2.3z M10.1,12.4H3.9V8.6V4.7h6.2V12.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGarbage);
export default __webpack_public_path__ + "static/media/icon_garbage.385900b8b1cd1f5f0cf02440a50c7ac2.svg";
export { ForwardRef as ReactComponent };